enum PickListComponentEnum {
    PREFORM = "preform",
}

export default PickListComponentEnum;
